import Vue from 'vue'
import locale from 'element-ui/lib/locale'
import elementEN from 'element-ui/lib/locale/lang/en'
import {
  Tabs, TabPane, Dropdown, DropdownMenu, DropdownItem, Icon, Carousel, CarouselItem, Collapse,
  CollapseItem, Dialog, Form, FormItem, Checkbox, CheckboxButton, CheckboxGroup, Input
} from 'element-ui'

locale.use(elementEN)

Vue.use(Tabs).use(TabPane).use(Dropdown).use(DropdownMenu).use(DropdownItem).use(Icon).use(Carousel).use(CarouselItem).use(Collapse).use(CollapseItem).use(Dialog).use(Form).use(FormItem).use(Checkbox).use(CheckboxButton).use(CheckboxGroup).use(Input)
